import { IRequestQuery } from '../types'

export interface IAgentCategory {
  code: string
  is_hidden: boolean
  label: string
}

export enum AGENT_STATUS {
  healthy = 'healthy',
  unavailable = 'unavailable',
}

export interface IAgent {
  agent_id: string
  name: string
  slug: string
  description: string
  greeting: string
  category: IAgentCategory
  start_commands: string[]
  file_upload_extensions: string[]
  status: AGENT_STATUS
}

export interface IListResponse<T> {
  count: number
  next: string
  previous: string
  results: Array<T>
}

export interface IListAgentRequestQuery extends IRequestQuery {
  category: string[]
  search: string
}

export interface IListAgentCategoryRequestQuery extends IRequestQuery {
  is_hidden: boolean
}

export type IListAgentCategoryResponse = IListResponse<IAgentCategory>
export type IListAgentResponse = IListResponse<IAgent>

export interface IAgentsByCategory {
  [categoryCode: string]: {
    items: IAgent[]
    total: number
    next: string
    limit: number
    page: number
  }
}
